import { InputLabel } from '@mui/material';
import { BrandKey } from '@prismamedia/one-brandkey';
import { GetRecipeCategoriesChildrenQuery_categories_Category } from '__generated__/queries-recipe';
import { CategoryStatus } from '__generated__/queries-web';
import { useGetCategoriesChildren } from 'apollo/queries/categories.recipe.graphql';
import { Suggest } from 'components/Suggest';
import { SuggestItemType } from 'components/Suggest/types';
import { flatten } from 'components/Suggest/utils';
import { AutomationConfigType } from 'pages/NewsletterPage/NewsletterEditPage/Generalities/AutomationFields';
import React from 'react';
import { getFilteredBrandKey } from 'utils/queries/variables';

interface RecipeCategoriesSelectProps {
  brandKey: BrandKey;
  automationConfig?: AutomationConfigType;
  onChange: (selectedCategoriesId: string[]) => void;
}

export const RecipeCategoriesSelect: React.FC<RecipeCategoriesSelectProps> = (
  props,
) => {
  const { automationConfig, brandKey, onChange } = props;

  const [categories, setCategories] = React.useState<
    GetRecipeCategoriesChildrenQuery_categories_Category[]
  >([]);
  const [selectedCategories, setSelectedCategories] = React.useState<
    SuggestItemType[]
  >([]);

  const flatCategories = React.useRef<SuggestItemType[]>([]);

  const getCategories = useGetCategoriesChildren();

  const fetchCategories = async () => {
    const { categories: data } = await getCategories({
      status: CategoryStatus.Published,
      ...getFilteredBrandKey(brandKey),
    });
    // eslint-disable-next-line immutable/no-mutation
    flatCategories.current = flatten(data);
    setCategories(data);
    setSelectedCategories(
      findSelectedCategories(automationConfig?.categoryIds || []),
    );
  };

  const findSelectedCategories = (categoryIds: string[]) => {
    if (categoryIds.length === 0 || flatCategories.current.length === 0) {
      return [];
    }

    return flatCategories.current.filter(
      (flatCategorie) => categoryIds.indexOf(flatCategorie.id) !== -1,
    );
  };

  React.useEffect(() => {
    setSelectedCategories(
      findSelectedCategories(automationConfig?.categoryIds || []),
    );
  }, [automationConfig]);

  React.useEffect(() => {
    fetchCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <InputLabel shrink>Catégories :</InputLabel>
      <Suggest
        selectedItems={selectedCategories}
        placeholder="Rechercher une catégorie"
        suggestions={categories}
        multiple={true}
        isPrefetched
        onChange={(items) => onChange(items.map((i) => i.id))}
      />
    </>
  );
};
